import React, { useEffect, useState } from "react";
import { Button, Col, Row, Modal, ModalBody, Input } from "reactstrap";
import SelectBox from "../../../components/SelectBox";
import { LoggedUserType, SelectOptionType } from "../../../models/GlobalModels";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import Label from "../../../components/Label";
import KDatePicker from "../../../components/KDatePicker";
import { DEFAULT_OPTION } from "../../../utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import {
  getICVDownloadCSV,
  getICVInfoAPICall,
  getICVPolicyReport,
  icvGetAllLevel5DataAPICall,
  icvGetAllSeasonsDataAPICall,
  icvGetAllVillagesDataAPICall,
  icvGetCropBySearchAPICall,
  icvGetDistrictsDataAPICall,
  icvGetMandalDataAPICall,
  icvGetStatesDataAPICall,
  icvGetYearDataAPICall,
} from "../../../api/icvActivityAPI";
import { FormUtils } from "../../../utils/FormUtils";
import moment from "moment";
import {
  ICVActivityFilterType,
  ICVFilterTYpe,
} from "../../../models/ICVActivitiesModels";
import "../icvActivities/ICVStyles.css";
import { toast } from "react-toastify";
import {
  handleICVGetDistrictDataSlice,
  handleICVGetDownLoadCSVDataSlice,
  handleICVGetInfoDataSlice,
  handleICVGetLevel5DataSlice,
  handleICVGetMandalDataSlice,
  handleICVGetPolicyReportDataSlice,
  handleICVGetVillagesDataSlice,
} from "../../../redux/slices/icvActivitySlice";
import {
  dateConverter,
  dateConverterWithoutAddingDays,
} from "../../../utils/Util";
import { loginSelector } from "../../../redux/slices/loginSlice";
import Refresh from "../../../assets/img/refresh.svg";
import SendIcon from '@mui/icons-material/Send';
import DownloadIcon from "../../../assets/img/download.svg";
import { filterOptionsByRole } from "../../../utils/Util";
import RestartAltTwoToneIcon from '@mui/icons-material/RestartAltTwoTone';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import SearchBox from "../../../components/SearchBox";

// Mock data for the select boxes
interface ICVFilterProps {
  onApplyFilters: (ICVFilter: ICVFilterTYpe, shouldCallAPI?: boolean) => void;
  search: string;
  setSearch: (data: string) => void;
  setSearchQuery: (data: string) => void;
}
const ICVActivitesTab = ({ onApplyFilters, search, setSearch, setSearchQuery }: ICVFilterProps) => {
  const user: LoggedUserType = useSelector(loginSelector).user;
  const {
    storeICVGetStatesData,
    storeICVGetSeasonsData,
    storeICVGetYearData,
    storeICVGetDistrictData,
    storeICVGetMandalData,
    storeICVGetPMFBYVillagesData,
    storeICVGetDownLoadCSVData,
    storeICVGetVillagesData,
    storeICVGetLevel5Data,
    storeICVGetCropsMastersData,
    storeICVGetFailedReportData,
    storeICVGetPolicyReportData,
  } = useSelector((state: any) => state.icvActivity);
  const [icvFilter, setIcvFilter] = useState<ICVFilterTYpe>({
    season: DEFAULT_OPTION,
    year: DEFAULT_OPTION,
    state: DEFAULT_OPTION,
    district: DEFAULT_OPTION,
    mandal: DEFAULT_OPTION,
    patwarName: [],
    fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
    toDate: undefined,
    cropVillage: [],
    cropId: [],
    kmlId: ''
  });
  const dispatch: any = useDispatch();
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [isResetEnabled, setIsResetEnabled] = useState(false);

  const handleReset = () => {
    // Clear the search query // Clear the search filter
    dispatch(handleICVGetDistrictDataSlice({}));
    dispatch(handleICVGetMandalDataSlice({}));
    dispatch(handleICVGetLevel5DataSlice({}));
    dispatch(handleICVGetVillagesDataSlice({}));
    setSelectedValues([]);
    setIcvFilter({
      // Reset to default filter values
      season: DEFAULT_OPTION,
      year: DEFAULT_OPTION,
      state: DEFAULT_OPTION,
      district: DEFAULT_OPTION,
      mandal: DEFAULT_OPTION,
      patwarName: [],
      fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
      toDate: undefined,
      cropVillage: [],
      cropId: [],
      kmlId: ''
    });
    // Call onApplyFilters with shouldCallAPI = false to prevent API call
    onApplyFilters({
      season: DEFAULT_OPTION,
      year: DEFAULT_OPTION,
      state: DEFAULT_OPTION,
      district: DEFAULT_OPTION,
      mandal: DEFAULT_OPTION,
      patwarName: [],
      fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
      toDate: undefined,
      cropVillage: [],
      cropId: [],
      kmlId: ''
    }, false); // Pass false to prevent API call
    setSearch('');
    setSearchQuery('');
    setIsResetEnabled(false);
    toast.success('Filter criteria is cleared');
  };

  const handleApplyFilters = () => {
    setIcvFilter({
      season: DEFAULT_OPTION,
      year: DEFAULT_OPTION,
      state: DEFAULT_OPTION,
      district: DEFAULT_OPTION,
      mandal: DEFAULT_OPTION,
      patwarName: [],
      fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
      toDate: undefined,
      cropVillage: [],
      cropId: [],
      kmlId: ''
    });
  };

  useEffect(() => {
    // Fetch initial data on component mount
    dispatch(icvGetStatesDataAPICall());
    dispatch(icvGetAllSeasonsDataAPICall());
    dispatch(icvGetYearDataAPICall());
    dispatch(icvGetCropBySearchAPICall("")); // Assuming this fetches crop data
  }, [dispatch]);

  const onchangeDropdown = (label: string, event: SelectOptionType) => {
    switch (label) {
      case "state":
        dispatch(handleICVGetDistrictDataSlice({}));
        dispatch(handleICVGetMandalDataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        if (event && event.value) {
          const stateValue = (event.value);
          dispatch(icvGetDistrictsDataAPICall(stateValue));
          dispatch(icvGetCropBySearchAPICall("", stateValue));
        }
        else {
          dispatch(icvGetCropBySearchAPICall(""));
        }

        setIcvFilter((prev) => ({
          ...prev,
          state: event,
          district: DEFAULT_OPTION, // Reset district dropdown
          mandal: DEFAULT_OPTION, // Reset mandal dropdown
          patwarName: [], // Reset patwar dropdown
          cropVillage: [], // Reset crop village selection
        }));
        break;

      case "district":
        dispatch(handleICVGetMandalDataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        if (typeof icvFilter?.state?.value === "string") {
          if (event?.value) {
            const districtValue = (event?.value);
            dispatch(
              icvGetMandalDataAPICall(
                (icvFilter?.state?.value),
                districtValue
              )
            );
            dispatch(icvGetCropBySearchAPICall("", icvFilter?.state?.value, districtValue));
          }
          else {
            dispatch(icvGetCropBySearchAPICall("", icvFilter?.state?.value,));
          }
        }
        else {
          dispatch(icvGetCropBySearchAPICall(""));
        }

        setIcvFilter((prev) => ({
          ...prev,
          district: event,
          mandal: DEFAULT_OPTION, // Reset mandal dropdown
          patwarName: [], // Reset patwar dropdown
          cropVillage: [], // Reset crop village selection
        }));
        break;

      case "mandal":
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        if (
          typeof icvFilter?.state?.value === "string" &&
          typeof icvFilter?.district?.value === "string" &&
          event?.value
        ) {
          const mandalValue = (event?.value); 
          dispatch(
            icvGetAllVillagesDataAPICall(
              (icvFilter?.state?.value),
              (icvFilter?.district?.value),
              mandalValue
            )
          );
          dispatch(
            icvGetAllLevel5DataAPICall(
              (icvFilter?.state?.value),
              (icvFilter?.district?.value),
              mandalValue
            )
          );
        }

        setIcvFilter((prev) => ({
          ...prev,
          mandal: event,
          patwarName: [], // Reset patwar dropdown
          cropVillage: [], // Reset crop village selection
        }));
        break;

      case "cropVillage":
        setIcvFilter((prev: any) => ({
          ...prev,
          cropVillage: event?.label ? [event] : [], // Set the selected crop village
        }));
        break;
      case "season":
        // Here event will be the selected option object, so we directly set it
        setIcvFilter((prev) => ({
          ...prev,
          season: event, // Update the season to the selected object (e.g., { label: 'Winter', value: 'winter' })
        }));
        break;
      case "year":
        setIcvFilter((prev) => ({
          ...prev,
          year: event, // Store the whole selected option object
        }));
        break;
      default:
        break;
    }
  };
  
  const statesData = FormUtils.convertDataList(
    storeICVGetStatesData?.data ?? []
  );

  const seasonsData = FormUtils.convertDataListValue(
    storeICVGetSeasonsData?.data ?? []
  );
  const yearData = FormUtils.convertToDataListObject(
    storeICVGetYearData?.data ?? []
  );
  const districtData = FormUtils.convertDataList(
    storeICVGetDistrictData?.data ?? []
  );
  const mandalData = FormUtils.convertDataList(
    storeICVGetMandalData?.data ?? []
  );
  const level5Data = FormUtils.convertDataList(
    storeICVGetLevel5Data?.data ?? []
  );
  const villagesData = FormUtils.convertVillagesDataList(
    storeICVGetVillagesData?.data ?? []
  );
  const cropMastersData = FormUtils.convertDataList(
    storeICVGetCropsMastersData?.data ?? []
  );

  // Filter options based on user role and accessed states/districts
  const filteredStatesData = filterOptionsByRole(
    statesData,
    user?.roleId || 0,
    user?.accessedStates || [],
    [],
    'states'
  );
  const filteredDistrictData = filterOptionsByRole(
    districtData,
    user?.roleId || 0,
    [],
    user?.accessedDistricts || [],
    'districts'
  );

  const handleCropVillageChange = (values: any) => {
    // Should log the selected values
    setIcvFilter((prev) => {
      return { ...prev, cropVillage: values };
    });
  };
  const handleCropGramPanchayatChange = (values: any) => {
    setIcvFilter((prev) => {
      return { ...prev, patwarName: values };
    });
  };
  const handleCropNameChane = (values: any) => {
    // Should log the selected values
    setIcvFilter((prev) => {
      return { ...prev, cropId: values };
    });
  };


  return (
    <>
      <div className="filter-section">
        <Row>
          <Col xs={6} md={2}>
            <SelectBox
              label="State"
              options={filteredStatesData}
              value={icvFilter.state}
              className="css-select-bg"
              onChange={(event) => onchangeDropdown("state", event)}
            />
          </Col>
          <Col xs={6} md={2}>
            <SelectBox
              label="District"
              options={filteredDistrictData}
              value={icvFilter.district}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("district", value)}
            />
          </Col>
          <Col xs={6} md={2}>
            <SelectBox
              label="Tehsil/Block"
              options={mandalData}
              value={icvFilter.mandal}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("mandal", value)}
            />
          </Col>
          <Col xs={4} md={2}>
            <MultiSelectDropdown
              options={level5Data}
              label="Gram Panchayat Name"
              value={selectedValues}
              onChange={handleCropGramPanchayatChange}
            />
          </Col>
          <Col xs={4} md={2}>
            <MultiSelectDropdown
              options={villagesData}
              label="Crop village"
              value={selectedValues}
              onChange={handleCropVillageChange}
            />
          </Col>
          <Col xs={6} md={2}>
            <SelectBox
              label="Season"
              options={seasonsData}
              value={icvFilter.season}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("season", value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={2}>
            <SelectBox
              label="Year"
              options={yearData}
              value={icvFilter.year}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("year", value)}
            />
          </Col>
          <Col xs={12} md={2} lg={2}>
            <KDatePicker
              label="From Date"
              value={icvFilter.fromDate}
              minDate={moment().subtract(1, "years").toDate()}
              maxDate={new Date()}
              onChange={(date: any) => {
                setIcvFilter({
                  ...icvFilter,
                  fromDate: date,
                  toDate: undefined,
                });
              }}
              labelIcon={<InfoTwoToneIcon className="label-icon-date-picker" />}
              labelIconTooltipContent={'Survey Completion From Date'}
            />
          </Col>
          <Col xs={12} md={2} lg={2}>
            <KDatePicker
              disabled={icvFilter.fromDate === undefined}
              label="To Date"
              minDate={icvFilter.fromDate}
              maxDate={new Date()}
              value={icvFilter.toDate}
              onChange={(date: any) => {
                setIcvFilter({
                  ...icvFilter,
                  toDate: date,
                });
              }}
              labelIcon={<InfoTwoToneIcon className="label-icon-date-picker"/>}
              labelIconTooltipContent={'Survey Completion To Date'}
            />
          </Col>
          <Col xs={6} md={3}>
            <MultiSelectDropdown
              options={cropMastersData}
              label="Crop Name"
              value={selectedValues}
              onChange={handleCropNameChane}
            />
          </Col>
          <Col xs={6} md={3}>
            <div style={{ position: "relative" }}>
              <SearchBox
                label="KML ID"
                placeHolder="Search with KML ID"
                value={icvFilter.kmlId}
                onChange={(e: any) => {
                  setIcvFilter({
                    ...icvFilter,
                    kmlId: e?.target?.value,
                  });
                }}
              />
            </div>
          </Col>
          <Col xs={6} md={3} className="d-flex align-items-center pt-1 mt-3">
            <Button
               variant="contained"
               className="cl-btn-outline-primary  d-flex align-items-center justify-content-between"
               onClick={handleReset}
             >
              Reset
              <RestartAltTwoToneIcon/>
            </Button>
            <Button
               variant="contained"
               className="mx-2 cl-btn-primary  d-flex align-items-center"
               onClick={() => {
                 onApplyFilters(icvFilter, true); // Pass true to ensure API call
                 setSearch(search);
                 setIsResetEnabled(true);
               }}
             >
              Submit
              <SendIcon sx={{ fontSize: '18px', marginLeft: '5px' }} />
            </Button>
          </Col>
        </Row>
      </div>     
    </>
  );
};

export default ICVActivitesTab;
